import { countryAlpha3ToAlpha2 } from "../../../lib/Constants";

export function convertFromGoogleAddressValidate(components) {
  /**
   *
   * @param {*} type addressComponents from Google Address Validate API
   * @returns an Address like type {}
   */
  const get = (type) => {
    const comp = components.find((c) => c.componentType === type);
    return comp?.componentName?.text || "";
  };

  return {
    address: [get("street_number"), get("route")].filter(Boolean).join(" "),
    suiteAddress: get("subpremise"),
    city: get("locality"),
    stateAddress: get("administrative_area_level_1"),
    country: countryAlpha3ToAlpha2[get("country")] || null,
    zipCode: [get("postal_code"), get("postal_code_suffix")]
      .filter(Boolean)
      .join("-"),
  };
}

export function addAddressDate(address, from, to) {
  const addressWithDate = {
    ...address,
    fromDate: from,
    toDate: to,
  };
  return addressWithDate;
}
